import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { MD } from "./mdTheme";

/** Compact section label — ExDashboard-scale, white paper */
const SectionHeader = ({ eyebrow, title, aside }) => (
  <Paper
    elevation={0}
    sx={{
      bgcolor: "#fff",
      border: `1px solid ${MD.line}`,
      borderRadius: "8px",
      boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
      mt: 0.25,
      px: 1.25,
      py: 0.75,
      width: "100%",
    }}
  >
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      useFlexGap
      spacing={1}
      sx={{ width: "100%" }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          component="div"
          sx={{
            color: MD.link,
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: "0.08em",
            lineHeight: 1.2,
            m: 0,
            textTransform: "uppercase",
          }}
        >
          {eyebrow}
        </Typography>
        <Typography
          component="h2"
          sx={{
            color: MD.fg,
            fontSize: 13.5,
            fontWeight: 700,
            lineHeight: 1.25,
            m: 0,
            mt: 0.125,
          }}
        >
          {title}
        </Typography>
      </Box>
      {aside ? (
        <Typography sx={{ color: MD.muted, fontSize: 11, fontWeight: 500, m: 0 }}>
          {aside}
        </Typography>
      ) : null}
    </Stack>
  </Paper>
);

export default SectionHeader;
